/**
 * @author Harshitha.k
 * @description 
 */

import React, { useEffect, useRef, useState } from 'react';
import { Input, Form, Select, Button, message } from 'antd';
import './reportConfig.css';

const { Option } = Select;

// const reorder = (list, startIndex, endIndex) => {
//   const result = Array.from(list);
//   const [removed] = result.splice(startIndex, 1);
//   result.splice(endIndex, 0, removed);
//   return result;
// };

const TableConfigCustomization = ({ tableProperties: initialTableProperties, jsonSaveObject }) => {
  const [tableProperties, setTableProperties] = useState(initialTableProperties || []);
  const [activeKey, setActiveKey] = useState([]);
  const [state,setState] = useState('');
  const userRef = useRef();

  useEffect(() => {
    if (initialTableProperties) {
      const {
        bordered,
        isCursorPointer,
        downloadXLXS,
        horizontalScroll,
        columnFilter,
        prepareDynamicColumns
      } = initialTableProperties;
      const borderedValue = (bordered === true || bordered === 'true') ? 'true' : 'false';
      const isCursorPointerValue = (isCursorPointer === true || isCursorPointer === 'true') ? 'true' : 'false';
      const downloadXLXSValue = (downloadXLXS === true || downloadXLXS === 'true') ? 'true' : 'false';
      const horizontalScrollValue = (horizontalScroll === true || horizontalScroll === 'true') ? 'true' : 'false';
      const columnFilterValue = (columnFilter === true || columnFilter === 'true') ? 'true' : 'false';
      const enableValue = (prepareDynamicColumns?.enable === true || prepareDynamicColumns?.enable === 'true') ? 'true' : 'false';

      userRef.current.setFieldsValue({
        bordered: borderedValue,
        isCursorPointer: isCursorPointerValue,
        downloadXLXS: downloadXLXSValue,
        horizontalScroll: horizontalScrollValue,
        columnFilter: columnFilterValue,
        prepareDynamicColumns: {
          ...prepareDynamicColumns,
          enable: enableValue
        }
      });
    }
  }, [initialTableProperties]);

  // const onDragEnd = (result) => {
  //   if (!result.destination) {
  //     return;
  //   }
  //   const reorderedProperties = reorder(tableProperties, result.source.index, result.destination.index);
  //   setTableProperties(reorderedProperties);
  //   jsonSaveObject(reorderedProperties, 'tableConfiguration');
  // };

  const handleFieldChange = (value, colName) => {
    setTableProperties((prev) => {
      const updatedProperties = { ...prev, [colName]: value };
      jsonSaveObject(updatedProperties, 'tableConfiguration');
      return updatedProperties;
    });
  };

  const handleChange = (value, keyName, key) => {
    setTableProperties((prev) => {
      const updatedPropertiesData = { ...prev };
  
      // Ensure the nested object exists
      if (!updatedPropertiesData[keyName]) {
        updatedPropertiesData[keyName] = {};
      }
  
      updatedPropertiesData[keyName][key] = value;
      jsonSaveObject(updatedPropertiesData, 'tableConfiguration');
      return updatedPropertiesData;
    });
  };
  

  const tableSave = (e) => {
    e.preventDefault();
    userRef.current.validateFields().then(async () => {
      const item = tableProperties.downloadExcelPayload;
      if (tableProperties.downloadExcel && (!item.PortName || !item.Name || !item.Consumption)) {
        message.error('Please fill downloadExcelPayload fields');
      } else {
        jsonSaveObject(tableProperties, 'tableConfiguration');
        message.success('TableConfiguration Validated Successfully');
        setActiveKey(activeKey);
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 4 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    }
  };

  const evenRowColor = [
    '#f5222d', '#bfbfbf', '#1890ff', '#fadb14', '#a0d911',
    '#fa541c', '#eb2f96', '#13c2c2', '#000000', '#ffd8bf'
  ];
  const oldRowColor = [
    '#ff7875', '#f0f0f0', '#69c0ff', '#fff566', '#d3f261',
    '#ff9c6e', '#ffadd2', '#5cdbd3', '#f5f5f5', '#ffffb8'
  ];

  let item = tableProperties;
  return (
    <div style={{ margin: '50px' }}>
      {tableProperties ? (
        <div>
          <Form
            {...formItemLayout}
            layout="vertical"
            ref={userRef}
            name="user_form"
            initialValues={item || {}}
            autoComplete="off"
          >
            <Form.Item
              label="Bordered"
              name="bordered"
              rules={[
                {
                  required: false,
                  message: 'Please Provide bordered!'
                }
              ]}
            >
              <Select
                // value={bordered}
                style={{ width: '100%', showArrow: true }}
                onSelect={(value) => handleFieldChange(value, 'bordered')}
              >
                <Option value="true">TRUE</Option>
                <Option value="false">FALSE</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Exclude Keys"
              name="excludeKeys"
              rules={[
                {
                  required: false,
                  message: 'Please Provide excludeKeys!'
                }
              ]}
            >
              <Select
                mode="tags"
                allowClear
                // Allow multiple selections
                style={{ width: '100%' }}
                placeholder="Select keys to exclude"
                // value={state.newKey}// Controlled value
                onChange={(value) =>
                  setState({
                    tableProperties: {
                      ...tableProperties,
                      excludeKeys: value
                    }
                  })
                }
                // onSelect={(value) => handleFieldChangeData(value, 'excludeKeys')}
              >
                {tableProperties.excludeKeys &&
                  Array.isArray(tableProperties.excludeKeys) &&
                  tableProperties.excludeKeys.map((key) => (
                    <Option key={key} value={key}>
                      {key}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Conversion Key :"
              name="conversionKey"
              rules={[
                //item.downloadExcelPayload.portName
                { required: false, message: 'Please Provide conversionKey!' }
              ]}
            >
              <Input
                value={
                  item && item.downloadExcelPayload && item.downloadExcelPayload.conversionKey
                }
                onChange={(value) =>
                  handleChange(value, 'downloadExcelPayload', 'conversionKey')
                }
              />
            </Form.Item>

            <Form.Item
              label="Common Key :"
              name="commonKey"
              rules={[
                //item.downloadExcelPayload.portName
                { required: false, message: 'Please Provide commonKey!' }
              ]}
            >
              <Input
                value={item && item.downloadExcelPayload && item.downloadExcelPayload.commonKey}
                onChange={(value) =>
                  handleChange(value, 'downloadExcelPayload', 'commonKey')
                }
              />
            </Form.Item>

            <Form.Item
              label="Ignore Keys"
              name="ignoreKeys"
              rules={[
                {
                  required: false,
                  message: 'Please Provide ignoreKeys!'
                }
              ]}
            >
              <Select
                mode="tags" // Allow multiple selections
                style={{ width: '100%' }}
                placeholder="Select keys to exclude"
                value={item.ignoreKeys} // Controlled value
                onChange={(value) =>
                  setState({
                    tableProperties: {
                      ...tableProperties,
                      ignoreKeys: value
                    }
                  })
                }
                // onSelect={(value) => handleFieldChangeData(value, 'ignoreKeys')}
              >
                {tableProperties.ignoreKeys &&
                  Array.isArray(tableProperties.ignoreKeys) &&
                  tableProperties.ignoreKeys.map((key) => (
                    <Option key={key} value={key}>
                      {key}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="HorizontalScroll :"
              name="horizontalScroll"
              rules={[{ required: true, message: 'Please Select Option!' }]}
            >
              <Select
                value={item.horizontalScroll}
                style={{ width: '100%' }}
                onSelect={(value) => handleFieldChange(value, 'horizontalScroll')}
              >
                <Option value="true">TRUE</Option>
                <Option value="false">FALSE</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="TableSize :"
              name="tableSize"
              rules={[{ required: true, message: 'Please Provide TableSize!' }]}
            >
              <Input
                value={item.tableSize}
                style={{ width: '100%' }}
                type="number"
                onChange={(e) => handleFieldChange(e.target.value, 'tableSize')}
              />
            </Form.Item>
            <Form.Item
              label="NoResultMessage"
              name="noResultMessage"
              rules={[
                {
                  required: true,
                  message: 'Please Provide noResultMessage!'
                }
              ]}
            >
              <Select
                style={{ width: '100%', showArrow: true }}
                onSelect={(value) => handleFieldChange(value, 'noResultMessage')}
              >
                <Option value="No Records">No Records</Option>
                <Option value="No Data">No Data</Option>
                <Option value="Data Not Found">Data Not Found</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="IsCursorPointer :"
              name="isCursorPointer"
              rules={[
                {
                  required: true,
                  message: 'Please Provide noResultMessage!'
                }
              ]}
            >
              <Select
                // value={isCursorPointer}
                style={{ width: '100%' }}
                onSelect={(value) => handleFieldChange(value, 'isCursorPointer')}
              >
                <Option value="true">TRUE</Option>
                <Option value="false">FALSE</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="DownloadXLXS :"
              name="downloadXLXS"
              rules={[{ required: true, message: 'Please Select Option!' }]}
            >
              <Select
                style={{ width: '100%' }}
                onSelect={(value) => handleFieldChange(value, 'downloadXLXS')}
              >
                <Option value="true">TRUE</Option>
                <Option value="false">FALSE</Option>
              </Select>
            </Form.Item>
            <Form.Item
              label="Column Filter :"
              name="columnFilter"
              rules={[{ required: false, message: 'Please Select Option!' }]}
            >
              <Select
                style={{ width: '100%' }}
                onSelect={(value) => handleFieldChange(value, 'columnFilter')}
              >
                <Option value="true">TRUE</Option>
                <Option value="false">FALSE</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label={
                <div style={{ fontWeight: 'bold' }}>{'Dynamic Columns :'}</div>
              }
            >
              <Form.Item
                label="Enable :"
                name={['prepareDynamicColumns', 'enable']}
                rules={[{ required: false, message: 'Please Provide enable!' }]}
              >
                <Select
                  value={
                    state &&
                    state.prepareDynamicColumns &&
                    state.prepareDynamicColumns.enable
                  }
                  style={{ width: '100%' }}
                  onSelect={(value) =>
                    handleChange(value, 'prepareDynamicColumns', 'enable')
                  }
                >
                  <Option value="true">TRUE</Option>
                  <Option value="false">FALSE</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Is UTC Columns"
                name={['prepareDynamicColumns', 'isUTCColumns']}
                rules={[
                  {
                    required: false,
                    message: 'Please Provide isUTCColumns!'
                  }
                ]}
              >
                <Select
                  mode="tags"
                  style={{ width: '100%' }}
                  placeholder="Select keys to exclude"
                  value={item.isUTCColumns}
                  onSelect={(value) =>
                    handleChange(value, 'prepareDynamicColumns', 'isUTCColumns')
                  }
                >
                  <Option value="Date">Date</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="IsUTCFormat :"
                name={['prepareDynamicColumns', 'isUTCFormat']}
                rules={[
                  {
                    required: false,
                    message: 'Please Provide isUTCFormat!'
                  }
                ]}
              >
                <Input
                  value={
                    item && item.prepareDynamicColumns && item.prepareDynamicColumns.isUTCFormat
                  }
                  onChange={(value) =>
                    handleChange(value, 'prepareDynamicColumns', 'isUTCFormat')
                  }
                />
              </Form.Item>
              <Form.Item
                label="Fixed Width :"
                name={['prepareDynamicColumns', 'fixedWidth']}
                rules={[
                  {
                    required: false,
                    message: 'Please Provide fixedWidth!'
                  }
                ]}
              >
                <Input
                  value={
                    item && item.prepareDynamicColumns && item.prepareDynamicColumns.fixedWidth
                  }
                  onChange={(value) =>
                    handleChange(value, 'prepareDynamicColumns', 'fixedWidth')
                  }
                />
              </Form.Item>
            </Form.Item>

            <Form.Item
              label={
                <div style={{ fontWeight: 'bold' }}>{'Download Payload :'}</div>
              }
            >
              <Form.Item
                label="PortName :"
                name={['downloadExcelPayload', 'PortName']}
                rules={[
                  //item.downloadExcelPayload.portName
                  { required: false, message: 'Please Provide PortName!' }
                ]}
              >
                <Input
                  value={item && item.downloadExcelPayload && item.downloadExcelPayload.PortName}
                  onChange={(value) =>
                    handleChange(value, 'downloadExcelPayload', 'PortName')
                  }
                />
              </Form.Item>
              <Form.Item
                label="Name :"
                name={['downloadExcelPayload', 'Name']}
                rules={[{ required: true, message: 'Please Provide Name!' }]}
              >
                <Input
                  value={item && item.downloadExcelPayload && item.downloadExcelPayload.Name}
                  onChange={(value) => handleChange(value, 'downloadExcelPayload', 'Name')}
                />
              </Form.Item>
              <Form.Item
                label="Consumption :"
                name={['downloadExcelPayload', 'Consumption']}
                rules={[
                  {
                    required: true,
                    message: 'Please Provide Consumption!'
                  }
                ]}
              >
                <Input
                  value={
                    item && item.downloadExcelPayload && item.downloadExcelPayload.Consumption
                  }
                  onChange={(value) =>
                    handleChange(value, 'downloadExcelPayload', 'Consumption')
                  }
                />
              </Form.Item>
              <Form.Item
                label="Report Type :"
                name={['downloadExcelPayload', 'ReportType']}
                rules={[
                  {
                    required: false,
                    message: 'Please Provide ReportType!'
                  }
                ]}
              >
                <Input
                  value={
                    item && item.downloadExcelPayload && item.downloadExcelPayload.ReportType
                  }
                  onChange={(value) =>
                    handleChange(value, 'downloadExcelPayload', 'ReportType')
                  }
                />
              </Form.Item>
              <Form.Item
                label="Summary Type :"
                name={['downloadExcelPayload', 'SummaryType']}
                rules={[
                  {
                    required: false,
                    message: 'Please Provide SummaryType!'
                  }
                ]}
              >
                <Select
                  value={
                    item && item.downloadExcelPayload && item.downloadExcelPayload.SummaryType
                  }
                  style={{ width: '100%' }}
                  onSelect={(value) =>
                    handleChange(value, 'prepareDynamicColumns', 'SummaryType')
                  }
                >
                  <Option value="true">TRUE</Option>
                  <Option value="false">FALSE</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="Summary Report Type :"
                name={['downloadExcelPayload', 'SummaryReportType']}
                rules={[
                  {
                    required: false,
                    message: 'Please Provide SummaryReportType!'
                  }
                ]}
              >
                <Input
                  value={
                    item &&
                    item.downloadExcelPayload &&
                    item.downloadExcelPayload.SummaryReportType
                  }
                  onChange={(value) =>
                    handleChange(value, 'downloadExcelPayload', 'SummaryReportType')
                  }
                />
              </Form.Item>
            </Form.Item>
            <Form.Item
              label={<div style={{ fontWeight: 'bold' }}>{'Styles:'}</div>}
            >
              <Form.Item label="TextAlign :">
                <Select
                  style={{ width: '100%', showArrow: true }}
                  defaultValue={item && item.style && item.style.textAlign}
                  onSelect={(value) => handleChange(value, 'style', 'textAlign')}
                >
                  <Option value="left">Left</Option>
                  <Option value="center">Center</Option>
                  <Option value="right">Right</Option>
                </Select>
              </Form.Item>
              <Form.Item label="FontWeight :">
                <Select
                  style={{ width: '100%', showArrow: true }}
                  defaultValue={item && item.style && item.style.fontWeight}
                  onSelect={(value) => handleChange(value, 'style', 'fontWeight')}
                >
                  <Option value="normal">Normal</Option>
                  <Option value="bold">Bold</Option>
                </Select>
              </Form.Item>
              <Form.Item label="EvenRowColor :">
                <Select
                  value={item && item.style && item.style.evenRowColor}
                  style={{ width: '100%', showArrow: true }}
                  placeholder="select or enter color"
                  onSelect={(value) => handleChange(value, 'style', 'evenRowColor')}
                >
                  {evenRowColor.map((colorItem, index) => (
                    <Option
                      key={index}
                      style={{ color: evenRowColor[index] }}
                      value={colorItem}
                    >
                      {colorItem}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="OddRowColor :">
                <Select
                  value={item && item.style && item.style.oldRowColor}
                  style={{ width: '100%', showArrow: true }}
                  placeholder="select or enter color"
                  onSelect={(value) => handleChange(value, 'style', 'oldRowColor')}
                >
                  {oldRowColor.map((colorItem, index) => (
                    <Option
                      key={index}
                      style={{ color: oldRowColor[index] }}
                      value={colorItem}
                    >
                      {' '}
                      {colorItem}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Form.Item>
          </Form>
          {/* <div className="configButton"> */}
          <Button
            type="primary"
            style={{ marginLeft: '60px' }}
            onClick={(e) => tableSave(e)}
          >
            ValidateJson
          </Button>
          {/* </div> */}
        </div>
      ) : null}
    </div>
  );
};

export default TableConfigCustomization;